import { ncbService } from './ncb';

/**
 * 🔧 對話記錄儲存服務
 * - 散客:僅本機 sessionStorage (關閉瀏覽器即清除)
 * - 常客/VIP:NCB 雲端儲存 (永久保存)
 */

const STORAGE_KEY_PREFIX = 'midnight_bar_chat_';

/**
 * 判斷是否為付費會員 (有雲端儲存權限)
 */
const isPaidUser = (user) => {
  if (!user) return false;
  const tier = user.subscription_tier || 'free';
  return tier !== 'free';
};

/**
 * 儲存對話訊息
 */
export const saveConversation = async (characterId, messages, user) => {
  const storageKey = `${STORAGE_KEY_PREFIX}${characterId}`;

  // 🔧 散客:只存 sessionStorage
  if (!isPaidUser(user)) {
    sessionStorage.setItem(storageKey, JSON.stringify(messages));
    return;
  }

  // 🔧 付費會員:存 NCB 雲端
  try {
    // 先檢查是否已有對話記錄
    const existingConversations = await ncbService.dataRead(
      'conversations',
      `filter[user_id]=${user.id}&filter[character_id]=${characterId}`
    );

    if (existingConversations.data && existingConversations.data.length > 0) {
      // 更新現有對話
      const conversationId = existingConversations.data[0].id;
      await ncbService.dataUpdate('conversations', conversationId, {
        messages: messages,
        updated_at: new Date().toISOString(),
      });
    } else {
      // 建立新對話
      await ncbService.dataCreate('conversations', {
        user_id: user.id,
        character_id: characterId,
        messages: messages,
      });
    }

    // 同時也存一份到 sessionStorage 作為快取
    sessionStorage.setItem(storageKey, JSON.stringify(messages));
  } catch (error) {
    console.error('❌ 雲端儲存失敗,降級為本機儲存:', error);
    // 如果雲端儲存失敗,至少保存到本機
    sessionStorage.setItem(storageKey, JSON.stringify(messages));
  }
};

/**
 * 載入對話訊息
 */
export const loadConversation = async (characterId, user) => {
  const storageKey = `${STORAGE_KEY_PREFIX}${characterId}`;

  // 🔧 散客:只從 sessionStorage 讀取
  if (!isPaidUser(user)) {
    const localData = sessionStorage.getItem(storageKey);
    return localData ? JSON.parse(localData) : null;
  }

  // 🔧 付費會員:優先從 NCB 雲端讀取
  try {
    const conversations = await ncbService.dataRead(
      'conversations',
      `filter[user_id]=${user.id}&filter[character_id]=${characterId}`
    );

    if (conversations.data && conversations.data.length > 0) {
      const messages = conversations.data[0].messages;
      // 同步到本機快取
      sessionStorage.setItem(storageKey, JSON.stringify(messages));
      return messages;
    }

    // 如果雲端沒有,嘗試從本機讀取
    const localData = sessionStorage.getItem(storageKey);
    return localData ? JSON.parse(localData) : null;
  } catch (error) {
    console.error('❌ 雲端讀取失敗,降級為本機讀取:', error);
    const localData = sessionStorage.getItem(storageKey);
    return localData ? JSON.parse(localData) : null;
  }
};

/**
 * 清除對話記錄
 */
export const clearConversation = async (characterId, user) => {
  const storageKey = `${STORAGE_KEY_PREFIX}${characterId}`;

  // 清除本機儲存
  sessionStorage.removeItem(storageKey);

  // 🔧 付費會員:同時清除雲端記錄
  if (isPaidUser(user)) {
    try {
      const conversations = await ncbService.dataRead(
        'conversations',
        `filter[user_id]=${user.id}&filter[character_id]=${characterId}`
      );

      if (conversations.data && conversations.data.length > 0) {
        const conversationId = conversations.data[0].id;
        await ncbService.dataDelete('conversations', conversationId);
      }
    } catch (error) {
      console.error('❌ 雲端刪除失敗:', error);
    }
  }
};